(function() {
  var Handler,
    slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Handler = require('resources/assets/coffee/Core/Handler').Handler;

  exports.Storage = (function() {
    function Storage() {
      this.data = {};
      this.key_count = 0;
    }

    Storage.prototype.all = function() {
      return this.data;
    };

    Storage.prototype.empty = function() {
      var k, ref, results, v;
      ref = this.data;
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(this["delete"](k));
      }
      return results;
    };

    Storage.prototype.keys = function() {
      var k, results;
      results = [];
      for (k in this.data) {
        results.push(k);
      }
      return results;
    };

    Storage.prototype.only = function() {
      var i, keep, key, len, result;
      keep = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      result = {};
      for (i = 0, len = keep.length; i < len; i++) {
        key = keep[i];
        if (this.data[key] != null) {
          result[key] = this.data[key];
        }
      }
      return result;
    };

    Storage.prototype.except = function() {
      var key, ref, reject, result, value;
      reject = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      result = {};
      ref = this.data;
      for (key in ref) {
        value = ref[key];
        if (indexOf.call(reject, key) < 0) {
          result[key] = value;
        }
      }
      return result;
    };

    Storage.prototype["delete"] = function(k) {
      var v;
      v = this.retrieve(k);
      if (v != null) {
        if (v instanceof Handler) {
          v.destroy();
        }
        delete this.data[k];
        return this.key_count = this.key_count - 1;
      }
    };

    Storage.prototype.retrieve = function(k, def) {
      var ref;
      if (def == null) {
        def = null;
      }
      return (ref = this.data[k]) != null ? ref : def;
    };

    Storage.prototype.store = function(k, v) {
      this.data[k] = v;
      return this.key_count = this.key_count + 1;
    };

    Storage.prototype.exists = function(k) {
      if (this.data[k] != null) {
        return true;
      } else {
        return false;
      }
    };

    Storage.prototype.each = function(callback) {
      var k, ref, results, v;
      if (callback == null) {
        callback = function() {
          return void 0;
        };
      }
      ref = this.data;
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(callback(k, v));
      }
      return results;
    };

    Storage.prototype.count = function() {
      return this.key_count;
    };

    return Storage;

  })();

}).call(this);
